// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const servine: PokeData = {
  "id": 496,
  "name": "servine",
  "height": 8,
  "weight": 160,
  "base_experience": 145,
  "types": [
    PokeType.GRASS
  ],
  "api_moves": [
    "slam",
    "vine-whip",
    "tackle",
    "wrap",
    "leer",
    "mega-drain",
    "leech-seed",
    "growth",
    "giga-drain",
    "magical-leaf",
    "leaf-blade",
    "wring-out",
    "gastro-acid",
    "leaf-storm",
    "coil",
    "leaf-tornado"
  ],
  "moves": [
    "vine-whip",
    "tackle",
    "leer",
    "leaf-tornado",
    "frenzy-plant",
    "solar-beam",
    "energy-ball",
    "power-whip",
    "grassy-terrain",
    "overgrowth",
    "bullet-seed",
    "synthesis",
    "aromatherapy"
  ],
  "evolution_chain": {
    "id": 256,
    "item": null,
    "species": [
      {
        "name": "snivy",
        "order": 496,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "servine",
        "order": 497,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": 495,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 17,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "serperior",
        "order": 498,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": 496,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 36,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 67.5,
    "speed": 83,
    "ability_power": 60
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
